// src/app/core/loading.service.ts
import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class LoadingService {
  private pending = 0;

  // visible = signal<boolean>
  private _visible = signal(false);
  isVisible = this._visible;

  // Timings (tu peux ajuster)
  private delayMs = 120; // anti-flicker: attendre avant d'afficher
  private minVisibleMs = 240; // durée min une fois affiché

  // Timers & timestamps
  private delayTimer: any = null;
  private hideTimer: any = null;
  private shownAt = 0;

  // ---- API ----
  start(): void {
    if (++this.pending === 1) {
      // 1er appel d'un lot → armer le délai
      this.clearDelayTimer();
      this.delayTimer = setTimeout(() => {
        // ⚠️ ne montrer que s'il reste des requêtes
        if (this.pending > 0) {
          this._visible.set(true);
          this.shownAt = Date.now();
        }
        this.delayTimer = null;
      }, this.delayMs);
    }
  }

  stop(): void {
    if (this.pending > 0) this.pending--;
    if (this.pending > 0) return; // d'autres requêtes en cours

    // Plus rien en cours → nettoyer le délai pour éviter un allumage tardif
    this.clearDelayTimer();

    // Si pas visible, rien à faire
    if (!this._visible()) {
      this.clearHideTimer();
      return;
    }

    // Respecter la durée minimale visible
    const elapsed = Date.now() - this.shownAt;
    if (elapsed >= this.minVisibleMs) {
      this._visible.set(false);
      this.shownAt = 0;
    } else {
      this.clearHideTimer();
      this.hideTimer = setTimeout(() => {
        this._visible.set(false);
        this.shownAt = 0;
        this.hideTimer = null;
      }, this.minVisibleMs - elapsed);
    }
  }

  // Option utile si tu veux tout remettre à zéro depuis l'UI
  reset(): void {
    this.pending = 0;
    this._visible.set(false);
    this.shownAt = 0;
    this.clearDelayTimer();
    this.clearHideTimer();
  }

  // ---- helpers ----
  private clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  }
  private clearHideTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }
}
